import {
  Button,
  chakra,
  HStack,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  UseDisclosureReturn,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { FeedbackRadioGroup } from "./rating-group";

interface FeedbackForm_T {
  forwardedRef: React.MutableRefObject<null>;
  onClose: UseDisclosureReturn["onClose"];
}

export const FeedbackForm = (props: FeedbackForm_T) => {
  const { forwardedRef, onClose } = props;
  const [message, setMessage] = useState("");
  const [emoji, setEmoji] = useState("");

  const toast = useToast();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const res = await fetch(`/api/feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        emoji: emoji,
        message: message,
      }),
    });
    const data = await res.json();
    toast({
      title: data?.title || "Thank You For Your Feedback",
      description: data.subtitle || undefined,
      status: res.status == 200 ? "success" : "warning",
      duration: 5000,
      isClosable: true,
    });
    if (res.status == 200) {
      // Track with segment so we can associate the message with the anonymous id
      /* track("feedback", {
        category: "submit",
        message_id: data.message_id,
      }); */
      setMessage("");
      setEmoji("");
      onClose();
    }
  };

  // If the form was successfully submitted, you can also return the `FeedbackSuccessPanel` instead
  return (
    <chakra.form onSubmit={handleSubmit}>
      <Stack spacing="3">
        <Textarea
          ref={forwardedRef}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Your Feedback"
          required
          focusBorderColor={useColorModeValue("blue.500", "blue.300")}
          _placeholder={{
            opacity: 1,
            color: useColorModeValue("gray.500", "whiteAlpha.700"),
          }}
          resize="none"
          maxLength={1024}
          className="feedback-input"
        />
        <Stack
          direction={{ base: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <FeedbackRadioGroup
            name="rating"
            options={["😍", "😀", "😐", "😨"]}
            onChange={setEmoji}
            className="feedback-reactions"
          />
          <HStack spacing="2">
            <Text textAlign="right" className="feedback-chars">
              {1024 - message.length}
            </Text>
            <Button
              type="submit"
              size="sm"
              variant="outline"
              className="feedback-submit"
            >
              Send
            </Button>
          </HStack>
        </Stack>
      </Stack>
    </chakra.form>
  );
};
